// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d5e1930e","147":"f62c9027","532":"1f4b8037","574":"1a4ab6e0","615":"87b99dd4","807":"4a412a39","818":"3b1400ca","899":"08e79356","900":"df15516e"}[chunkId] + ".chunk.js";
};